import { BuilderElement } from "@/types/elements";
import { configStore } from "@/store/store-accessor";

export function getBlankElement(): Omit<BuilderElement, "slug" | "name"> {
  const builderMode = configStore.builderMode || "breakdance";

  return {
    className: false,
    uiIcon: false,
    category: "other",
    badge: false,
    htmlTag: {
      default: "div",
      options: [],
      pathToControl: false
    },
    template: "Blank Element",
    attributes: false,
    cssTemplate: "%%SELECTOR%% { }",
    defaultCss: " ", // If it's empty PHP errors when creating the file even tho it works.
    defaultProperties: false,
    defaultChildren: false,
    controls: { contentSections: [], designSections: [], settingsSections: [] },
    dependencies: false,
    actions: false,
    nestingRule: { type: "final" },
    spacingBars: false,
    dynamicPropertyPaths: false,
    settings: false,
    addPanelRules: false,
    experimental: false,
    availableIn: [builderMode],
    order: 0,
    additionalClasses: false,
    projectManagement: false,
    propertyPathsToWhitelistInFlatProps: false,
    propertyPathsToSsrElementWhenValueChanges: false
  };
}
